// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons__button--3dN","demo":"Buttons__demo--2UY","play":"Buttons__play--1LZ","playImage":"Buttons__playImage--j14","missionsImage":"Buttons__missionsImage--2bt"};